module.exports = __webpack_public_path__ + "static/pic03-3285071209c5ac5fcdbc45b2dd0478b4.jpg";